import { getMatrixEnvironment } from '../utils/client'
import {
  PRESENCE_UPDATE,
  PRESENCE_UPDATE_SETTINGS,
  USER_PRESENCE_CHANGED,
} from '../actionTypes/presence'
import {
  selectPresence,
  selectCurrentContactMatrixUserId,
  selectCurrentContactMatrixUserPresence,
} from '../selectors/presence'

export function doUpdatePresence(presence) {
  return (dispatch, getState) => {
    const currentState = selectPresence(getState())
    if (currentState !== presence) {
      dispatch({
        type: PRESENCE_UPDATE,
        payload: {
          presence,
        },
      })
    }
  }
}

export function doUpdatePresenceSettings(settings) {
  return {
    type: PRESENCE_UPDATE_SETTINGS,
    payload: { settings },
  }
}

export function doGetUserPresence() {
  return async (dispatch, getState) => {
    const state = getState()
    if (selectCurrentContactMatrixUserPresence(state) !== 'unknown') return
    const client = await getMatrixEnvironment()
    const userId = selectCurrentContactMatrixUserId(state)
    if (!userId) return
    const { presence } = client.getUser(userId)
    dispatch({
      type: USER_PRESENCE_CHANGED,
      payload: presence,
      meta: { userId },
    })
  }
}
